<script>
import NotificationTemplate from '@/components/Notifications/General/NotificationTemplate';
import ProcessError from '@/components/Notifications/Login/ProcessError';
import EmailDeOutroProvedor from '@/components/Notifications/Login/EmailDeOutroProvedor';
import authenticationService from '@/services/Authentication/authenticationService.js';
import pessoasService from '@/services/Pessoas/pessoasService';
import { vueTopprogress } from 'vue-top-progress';
import logsService from '@/services/Logs/logsService';
import claimsService from '@/services/Authentication/claimsService';
import investorsService from '@/services/Investors/investorsService';
import Password from 'vue-password-strength-meter';

import settingsService from '@/services/Settings/settingsService';

import Firebase from 'firebase/app';
const GoogleProvider = new Firebase.auth.GoogleAuthProvider();
const FacebookProvider = new Firebase.auth.FacebookAuthProvider();

import Vue from 'vue';

import { PessoaCaracteristica, CWLRedirectRef, CWLStatusInvestidor } from '@/store/cwl_enums';

import HelperPlugin from '@/plugins/HelperPlugin';
Vue.use(HelperPlugin);

import store from '@/store/index';
import { email } from 'vuelidate/lib/validators';

export default {
  components: {
    vueTopprogress,
    Password,
  },
  data() {
    return {
      modalidade: process.env.VUE_APP_TYPE,
      submodalidade: process.env.VUE_APP_SUBTYPE,
      user: {},
      envPath: process.env.VUE_APP_ROOT_SITE,
      logoUrl: require(process.env.VUE_APP_LOGO_URL),
      socialLoginButtonDisabled: false,
      facebookDisabled: process.env.VUE_APP_FACEBOOK_LOGIN_ENABLED === 'false',
      titulo: '',
      allSettings: {},
    };
  },
  validations: {
    user: {
      email: {
        valid: email,
      },
    },
  },
  mounted() {
    try {
      const user = this.$store.getters.getPessoa;
      if (user && user.pessoa_id) {
        this.$router.push('/dashboard');
      }
      this.getSettings();
    } catch (e) {}
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE;
    },
    registerUrl() {
      const redirect = this.$route.query.redirect
        ? 'redirect=' + this.$route.query.redirect
        : '';

      const value = '/register?' + redirect;
      return value;
    },
    loggedInUser() {
      return this.$store.getters.isLoggedIn;
    },
    investorLogged() {
      return this.$store.getters.isLoggedInvestor;
    },
    currentPessoa() {
      return this.$store.getters.getPessoa;
    },
    ref() {
      return this.$route.params.ref;
    },
  },
  methods: {
    async getSettings() {
      this.allSettings = (await settingsService.getPublicSettings()) || {};
      let privateSettings = (await settingsService.getPrivateSettings()) || {};

      this.titulo = privateSettings.platformName || '';
    },
    redirectTo() {
      const ref = this.$route.params.ref || this.$route.query.ref;
      const id =
        this.$route.query.id || this.$store.getters.paymentCheckout.financingId;
      if (ref === 'site' || id) {
        const siteUrl = process.env.VUE_APP_FINANCING_PAGE.replace('{id}', id);
        window.top.location.href = siteUrl;
      } else if (ref == CWLRedirectRef.siteCriarCampanha) {
        this.$router.push('/add-financing');
      } else if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else {
        if ( this.currentPessoa.dados_complementares.approvalStatus != CWLStatusInvestidor.Aprovado
          && this.currentPessoa.dados_complementares.approvalStatus != CWLStatusInvestidor.EmAnalise ) {
          this.$router.push('/profile');
        }
        else {
          this.$router.push('/dashboard');
        }
      }
    },

    async loginWithCredentials() {
      this.$refs.topProgress.start();
      this.socialLoginButtonDisabled = true;

      const emailToLoggin = this.user.email.toLowerCase();

      try {
        const userFromFirebase =
          await authenticationService.loginWithCredentials(
            emailToLoggin,
            this.user.password,
          );

        this.handleLogin(userFromFirebase);
      } catch (error) {
        console.log('credentials login error', error);

        this.socialLoginButtonDisabled = false;
        this.$refs.topProgress.done();
        this.$notify({
          component: NotificationTemplate,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }
    },

    async loginWithGoogle() {
      this.socialLoginButtonDisabled = true;
      this.$refs.topProgress.start();

      try {
        const firebaseUser = await Firebase.auth().signInWithPopup(
          GoogleProvider,
        );
        this.handleLogin(firebaseUser);
      } catch (error) {
        console.log('google auth error', error);
        this.socialLoginButtonDisabled = false;
        let comp = ProcessError;
        if (error.code == 'auth/account-exists-with-different-credential') {
          comp = EmailDeOutroProvedor;
        }

        this.$refs.topProgress.done();
        if (error.code != 'auth/popup-closed-by-user') {
          this.$notify({
            component: comp,
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning',
            timeout: 3000,
          });
        }
      }
    },

    async loginWithFacebook() {
      this.$refs.topProgress.start();
      this.socialLoginButtonDisabled = true;

      try {
        const authUser = await Firebase.auth().signInWithPopup(
          FacebookProvider,
        );
        this.handleLogin(authUser);
      } catch (error) {
        console.error('facebook login error', error);
        let comp = ProcessError;
        this.socialLoginButtonDisabled = false;
        if (error.code == 'auth/account-exists-with-different-credential') {
          comp = EmailDeOutroProvedor;
        }

        this.$refs.topProgress.done();
        if (error.code != 'auth/popup-closed-by-user') {
          this.$notify({
            component: comp,
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'warning',
            timeout: 3000,
          });
        }
      }
    },
    async handleLogin(authUser) {
      try {
        const role = await claimsService.getUserClaim(authUser.user);
        const user = await pessoasService.getPessoaBy({id: undefined, email: authUser.user.email});

        const redirect = this.$route.query.redirect
          ? 'redirect=' + this.$route.query.redirect
          : '';

        if (user && !role) {
          this.socialLoginButtonDisabled = false;
          this.$notify({
            title: 'Ooopss',
            message:
              'Encontramos uma inconsistência no seu login! Por favor, entre em contato com o administrador.',
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
            timeout: 3000,
          });
          this.$router.push('/register?' + redirect);
        } else if (!user) {
          this.$store.commit('SET_USER_TEMP', authUser);

          this.$router.push('/register?' + redirect);
          this.$notify({
            title: 'Ooopss',
            message:
              'Você ainda não possui conta, por favor preencha os dados abaixo',
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
            timeout: 3000,
          });
        } else {
          this.$store.dispatch('login', authUser);
          const objCooke = this.$CWLCreatePessoaForCookie(user);
          this.$store.commit('SET_PESSOA', objCooke);
          if (store.getters.userClaim.role === 'investor') {
            store.commit(
              'SET_TERM_OF_USE_ACCEPTED',
              user.dados_complementares.termsOfUseAccepted,
            );
          }

          this.user.password = '';
          logsService.createNewLog(
            authUser,
            'loginWithCredentials',
            'SignIn',
            'POST',
            this.user,
          );

          const title = 'Olá ' + user.nome + '!';
          this.$notify({
            title: title,
            message: 'Bem vindo de volta!',
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
            timeout: 3000,
          });
          this.redirectTo();
        }
      } catch (error) {
        console.error('handle user error', error);
        this.socialLoginButtonDisabled = false;

        this.$refs.topProgress.done();
        this.$notify({
          component: ProcessError,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });
      }
    },

    navigateToSite() {
      window.top.location.href = this.envPath;
    },
    async createUser(userFromGoogle) {
      try {
        const user = {
          email: userFromGoogle.email,
        };

        const { uid, email } = userFromGoogle;

        user.maritalStatus = '';

        const pessoa = this.$CWLNewPessoaPadrao();
        pessoa.nome = userFromGoogle.displayName;
        pessoa.caracteristicas = [PessoaCaracteristica.Usuario];
        pessoa.dados_complementares = {
          user: {
            maritalStatus: '',
            email: email,
          },
          address: {
            state: '',
          },
          bank: {
            bankName: '',
          },
          profile: {
            personType: '',
            segment: '',
            value: '',
            profile: '',
          },
          fullName: userFromGoogle.displayName,
          approvalStatus: CWLStatusInvestidor.Incompleto,
          termsOfUseAccepted: true,
          termsOfUseDateAccepted: '',
        };
        pessoa.email.email = email;
        pessoa.emails.push(pessoa.email);

        const investorCreated = await investorsService.createNewInvestor(
          pessoa,
        );
        const investorFromFirebase = await investorsService.get(
          investorCreated.id,
        );
        const investor = investorFromFirebase.data();
        investor.id = investorFromFirebase.id;
        const objCooke = this.$CWLCreatePessoaForCookie(investor);
        this.$store.commit('SET_PESSOA', objCooke);

        await claimsService.setNewUserClaim(uid, email, 'investor');
        await claimsService.getUserClaim(userFromGoogle);

        const title = 'Olá ' + pessoa.nome + '!';
        this.$notify({
          title: title,
          message: 'Bem vindo de volta!',
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'success',
          timeout: 3000,
        });
        this.$refs.topProgress.done();
        this.redirectTo();
      } catch (e) {
        console.log(e);
        this.socialLoginButtonDisabled = false;
        this.$notify({
          component: ProcessError,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
          timeout: 3000,
        });

        this.$refs.topProgress.done();
      }
    },
  },
};
</script>

<template>
  <div class="sign-in">
    <div class="signin2"></div>

    <div class="card">
      <div class="back">
        <i class="fa fa-arrow-left" @click="navigateToSite()"></i>
      </div>

      <img class="auth-logo" :src="logoUrl" alt="Imobcoin" />

      <h1 v-if="modalidade == 'doacao'" class="auth-title">
        {{ appTitle }}
      </h1>

      <p class="auth-description">Para entrar, informe os dados abaixo:</p>

      <div class="social-network-buttons">
        <button
          @click="loginWithGoogle"
          class="btn social-btn"
          :disabled="socialLoginButtonDisabled"
        >
          Entrar com Google
        </button>

        <!--
        <button
          v-if="!facebookDisabled"
          @click="loginWithFacebook"
          class="btn social-btn"
          :disabled="socialLoginButtonDisabled"
        >
          Entrar com Facebook
        </button>
        -->
      </div>

      <form @submit.prevent="loginWithCredentials" class="login-form">
        <div class="form-group">
          <label class="control-label">Email</label>
          <input
            v-model="user.email"
            data-testId="email"
            type="email"
            class="form-control"
            placeholder="email@example.com"
            required
          />
          <div class="error" v-if="user.email != '' && !$v.user.email.valid">
            Informe um e-mail válido.
          </div>
        </div>

        <div class="form-group">
          <label class="control-label">Senha</label>
          <password
            v-model="user.password"
            :secureLength="6"
            :badge="false"
            :showStrengthMeter="false"
            :toggle="true"
            required
          />
        </div>

        <div class="form-group sign-in-row">
          <label
            class="control-label auth-helper-text"
            :class="{ disabled: socialLoginButtonDisabled }"
          >
            Não tem uma conta?
            <a
              :href="registerUrl"
              class="auth-link"
              :class="{ disabled: socialLoginButtonDisabled }"
            >
              Criar
            </a>
          </label>

          <label
            class="control-label auth-helper-text"
            :class="{ disabled: socialLoginButtonDisabled }"
          >
            <router-link
              to="/forgot-password"
              class="auth-link"
              :class="{ disabled: socialLoginButtonDisabled }"
            >
              Esqueci minha senha
            </router-link>
          </label>
        </div>

        <button
          type="submit"
          class="btn btn-primary"
          :disabled="socialLoginButtonDisabled"
        >
          Entrar
        </button>
      </form>
    </div>

    <vue-topprogress ref="topProgress"></vue-topprogress>
  </div>
</template>

<style scoped>
.sign-in {
  background: var(--imob-bg);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signin2 {
  display: none;
}

.sign-in > .card {
  background: var(--imob-white);
  border-radius: 8px;
  border: 1px solid var(--imob-border);
  box-shadow: var(--imob-header-shadow);
  padding: 2rem;
  width: 420px;
}

.back {
  margin-top: -10px;
  margin-bottom: 10px;
}

.back i {
  color: var(--imob-text);
  cursor: pointer;
  font-size: 18px;
}

.auth-logo {
  display: block;
  margin: 0 auto 28px auto;
  height: 56px;
}

.auth-title {
  font-size: 28px;
  color: var(--imob-text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
}

.auth-description {
  color: var(--imob-text-muted);
  text-align: center;
  margin-bottom: 20px;
}

.control-label {
  color: var(--imob-text);
  font-weight: 500;
  display: inline-block;
  margin-bottom: 8px;
}

.form-group {
  margin-bottom: 18px;
}

.form-control {
  width: 100%;
  border: 1px solid var(--imob-border);
  border-radius: 6px;
  color: var(--imob-text);
  background: var(--imob-white);
  padding: 10px 14px;
  transition: border 0.15s ease, box-shadow 0.15s ease;
}

.form-control:focus {
  border-color: var(--imob-magenta);
  outline: none;
  box-shadow: 0 0 0 2px rgba(237, 34, 139, 0.1);
}

.error {
  color: var(--imob-magenta);
  font-size: 13px;
  margin-top: 6px;
}

.social-network-buttons {
  margin-bottom: 20px;
}

.social-btn {
  width: 100%;
  border-radius: 999px;
  border: 1px solid var(--imob-border);
  background: var(--imob-white);
  color: var(--imob-text);
  font-weight: 500;
  padding: 12px;
  transition: all 0.15s ease;
}

.social-btn:hover:not(:disabled) {
  background: rgba(237, 34, 139, 0.08);
  color: var(--imob-magenta);
  border-color: var(--imob-magenta);
}

.sign-in-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.auth-helper-text {
  color: var(--imob-text-muted);
  font-weight: 400;
  margin-bottom: 0;
}

.auth-link {
  color: var(--imob-magenta);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease, background 0.15s ease;
}

.auth-link:hover {
  color: var(--imob-magenta);
  text-decoration: underline;
}

.auth-link.disabled,
.auth-helper-text.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

button.btn-primary {
  width: 100%;
  margin-top: 22px;
  border-radius: 999px;
  background: var(--imob-gradient);
  border: none;
  color: var(--imob-white);
  font-weight: 500;
  padding: 12px;
  transition: opacity 0.15s ease;
}

button.btn-primary:hover:not(:disabled) {
  opacity: 0.9;
}

button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* ajuste do componente vue-password-strength-meter */
::v-deep .Password {
  width: 100%;
}

::v-deep .Password__field {
  width: 100%;
  border: 1px solid var(--imob-border);
  border-radius: 6px;
  color: var(--imob-text);
  background: var(--imob-white);
  padding: 10px 14px;
  transition: border 0.15s ease, box-shadow 0.15s ease;
}

::v-deep .Password__field:focus {
  border-color: var(--imob-magenta);
  outline: none;
  box-shadow: 0 0 0 2px rgba(237, 34, 139, 0.1);
}

::v-deep .Password__toggle {
  color: var(--imob-text-muted);
}
</style>